(function () {
    'use strict';

    angular
        .module('generalReports')
        .controller('TargetsController', TargetsController);
    TargetsController.$inject = ['$uibModal','VirtualFairService', 'WebinarService','ExpoService','GeneralReportsService','SellerService', 'AdmService','$timeout', 'DTOptionsBuilder', '$scope', 'CurrentUser'];
    function TargetsController($uibModal, VirtualFairService, WebinarService, ExpoService, GeneralReportsService, SellerService, AdmService, $timeout, DTOptionsBuilder, $scope, CurrentUser) {
        var vm = this;

        vm.flag                  = false;
        vm.getSemesters          = getSemesters;
        vm.semesterSelected      = -1;
        vm.services              = [{id: 'physical-fairs', name : 'Physical Fairs'}, {id: 'virtual-fairs', name : 'Virtual Fairs'}, {id: 'webinars', name : 'Webinars'}];
        vm.serviceSelected       = 'physical-fairs';
        vm.expoSelected          = '';
        vm.getExpos              = getExpos;
        vm.getByFilter           = getByFilter;
        vm.tab                   = 1;
        vm.changeTab             = changeTab;
        vm.getEvents             = getEvents;
        vm.changeService         = changeService;
        vm.viewClients           = viewClients;
        vm.getSellers            = getSellers;
        vm.sellerSelected        = -1;
        vm.viewInfoClients       = viewInfoClients;
        vm.notSoldBySeller       = notSoldBySeller;
        vm.barColorsPaid         = barColorsPaid;
        vm.barColorsWaiting      = barColorsWaiting;
        vm.barColorsOverdue      = barColorsOverdue;
        vm.barColorsTargets      = barColorsTargets;
        vm.pendingInvoices       = pendingInvoices;
        vm.exhibitorsModal       = exhibitorsModal;
        vm.getTotalDue           = getTotalDue;
        vm.totalDue              = 0; 


        /*PAGINATION*/
        vm.pageChanged           = pageChanged;
        vm.setPage               = setPage;
        vm.to                    = [];
        vm.totalItems            = [];
        vm.currentPage           = null;
        vm.itemsPerPage          = [];
        vm.page                  = 1;

        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withOption('paging', false)
            .withOption('info', false);

        vm.dtOptions2 = DTOptionsBuilder.newOptions()
            .withOption('autoWidth', false);

        function getEvents()
        {
            if(vm.serviceSelected === 'physical-fairs' && vm.semesterSelected !== '')
            {
                vm.getExpos();
            }
            if(vm.serviceSelected === 'virtual-fairs' && vm.semesterSelected !== '')
            {
                vm.query = {};
                vm.query['semester'] = vm.semesterSelected;
                VirtualFairService.getAll(vm.query).then(function (response) {
                    vm.expos = response.data;
                });
            }
            if(vm.serviceSelected === 'webinars')
            {
                vm.expos = [];
                vm.query = {};
                vm.query['semester'] = vm.semesterSelected;
                WebinarService.selectWebinars(vm.query).then(function (response) {
                    angular.forEach(response, function(value) {
                        vm.expos.push({id : value.id, name : value.title});
                    });
                });
            }
        }

        function changeService()
        {
            vm.semesterSelected = '';
            vm.expoSelected = '';
        }

        function changeTab(tab){
            vm.tab = tab;
            if(tab === 8) {
                vm.pendingInvoices();
            }
        }

        function activate() {
            vm.getSemesters();
            vm.getSellers();
        }

        function getSemesters() {
            vm.semesters = [];
            ExpoService.getSemesters().then(function (response) {
                angular.forEach(response.data, function(value) {
                    this.push({id : value.semester, name : value.semester });
                }, vm.semesters);
                vm.semesters.unshift({id : -1, name: '--- All ---'});
            });
        }

        function getExpos() {
            vm.query = {};
            vm.query['semester'] = vm.semesterSelected;
            ExpoService.getExpoBySemester(vm.query).then(function (response) {
                vm.expos = response.data;
            });
        }

        function getSellers() {

            vm.sellers = [];
            AdmService.getSellers().then(function (response) {
                vm.sellers = response.data;
                vm.sellers.unshift({id : -1, name : '-- All -- '});
                // angular.forEach(response.data, function(value) {
                //     this.push({id : value.semester, name : value.semester });
                // }, vm.semesters);
            });
            // SellerService.getAll().then(function (response) {
            //     vm.sellers = response.data;
            //     vm.sellers.unshift({id : -1, name : '-- All -- '});
            //     // angular.forEach(response.data, function(value) {
            //     //     this.push({id : value.semester, name : value.semester });
            //     // }, vm.semesters);
            // });
        }

        function getByFilter() {
            vm.tab = 1;  
            vm.targets = {};
            vm.flag = false;
            vm.query = {};
            
            vm.query['semester'] = vm.semesterSelected;
            vm.query['service'] = vm.serviceSelected;

            if($scope.can('view_general_reports_targets_select_seller')) {
                vm.query['seller'] = vm.sellerSelected;
            } else {
                console.log(CurrentUser);
                vm.query['seller'] = CurrentUser.id;
            }
            if(typeof vm.expoSelected !== 'undefined') {
                vm.query['expo_id'] = vm.expoSelected;
            }
            GeneralReportsService.getTargets(vm.query).then(function (response) {
                vm.flag = true;
                vm.targets = response;                             
            });
        }

        function setPage (pageNo) {
            vm.currentPage = pageNo;
        }

        function pageChanged (pageNo) {
            vm.page = vm.currentPage;
            vm.getByFilter();
        }

        function viewClients(clients){
            $uibModal.open({
                templateUrl: 'templates/general-reports/targets/clients.modal.html',
                controller: 'TargetClientsController',
                controllerAs:'targetClients',
                resolve: {
                    clients : function () {
                        return clients;
                    }
                }
            });
        }

        function viewInfoClients(clients){
            $uibModal.open({
                templateUrl: 'templates/general-reports/targets/info.modal.html',
                controller: 'TargetInfoClientsController',
                controllerAs:'targetInfoClients',
                resolve: {
                    clients : function () {
                        return clients;
                    }
                }
            });
        }

        function notSoldBySeller(years)
        {
            vm.query = {};
            vm.query['years'] = years;
            GeneralReportsService.notSoldBySeller(vm.query).success(function(data, status, headers, config) {
                var anchor = document.createElement('a');
                anchor.href = 'data:attachment/csv;charset=utf-8,' + encodeURI(data);
                anchor.target = '_blank';
                anchor.download = 'report_targets_not_sold_within_years.csv';
                document.body.appendChild(anchor);
                anchor.click();
                $timeout(function () {
                    anchor.remove();
                }, 50);
            }).error(function(data, status, headers, config) {
                // handle error
            });
        }

        function barColorsPaid(row, series, type) {
            return vm.targets.graphs.paid.colors[row.x];
        }

        function barColorsWaiting(row, series, type) {
            return vm.targets.graphs.waiting.colors[row.x];
        }

        function barColorsOverdue(row, series, type) {
            return vm.targets.graphs.overdue.colors[row.x];
        }

        function barColorsTargets(row, series, type) {
            return vm.targets.performance.graph.colors[row.x];
        }


        function pendingInvoices() {
            let query = {};
            vm.totalDue = 0;
            query['service'] = vm.serviceSelected;
            if(vm.serviceSelected === 'physical-fairs' && vm.expoSelected > 0) {
                query['expo_id'] = vm.expoSelected;
            }
            if(vm.serviceSelected === 'virtual-fairs' && vm.expoSelected > 0) {
                query['virtual_fair_id'] = vm.expoSelected;
            }
            if(vm.sellerSelected > 0) {
                query['seller_id'] = vm.sellerSelected;
            }
            if(vm.semesterSelected != '') {
                query['semester'] = vm.semesterSelected;
            }
            vm.notInvoiced = {};
            GeneralReportsService.pendingInvoices(query).then(function (response) {
                vm.notInvoiced = response.data.not_invoiced;
                vm.getTotalDue();
            });
        }

        function exhibitorsModal (users) {
            $uibModal.open({
                templateUrl: 'templates/general-reports/targets/exhibitorsModal/exhibitorsModal.html',
                controller: 'ExhibitorsModalController',
                controllerAs:'exhibitorsModal',
                resolve:
                    {
                        users : function () {
                            return users;
                        }
                    }
            });
        }

        function getTotalDue() {            
            angular.forEach(vm.notInvoiced, function(exhibitor) {
                vm.totalDue = parseFloat(vm.totalDue) +  parseFloat(exhibitor.total_due);
            });

        }

        activate();
    }
})();